import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { IconInfo } from './Icons';
import './PnlScalingInfoModal.css';

export const DEFAULT_PNL_SCALING_PARAGRAPHS = [
  'Contract Multi is a multiplier for position size. It scales the historical PnL up or down so you can see what the same trades would look like at the number of contracts you trade.',
  'Example: if a strategy made $1,000 at 1 contract, setting Contract Multi to 3 shows $3,000 (3×). Setting it to 1 shows the base result.',
  'It is not an average or a fixed profit-per-contract — it proportionally scales the result of the actual historical trades.',
  'Note: the original trades may have used a different position size, and the trade count shown is the number of trades, not the number of contracts.',
];

/**
 * Centered overlay dialog (same pattern as Dashboard “Multi-TP Modeling Note”).
 */
export function PnlScalingInfoModal({
  open,
  onClose,
  title = 'Contract Multi — how it works',
  paragraphs = DEFAULT_PNL_SCALING_PARAGRAPHS,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="pnl-scaling-info-modal-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="pnl-scaling-info-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="pnl-scaling-info-modal-title"
      >
        <div className="pnl-scaling-info-modal-header">
          <h4 id="pnl-scaling-info-modal-title">{title}</h4>
          <button
            type="button"
            className="pnl-scaling-info-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            Close
          </button>
        </div>
        {paragraphs.map((text, i) => (
          <p
            key={i}
            className={`pnl-scaling-info-modal-text${i > 0 ? ' pnl-scaling-info-modal-text-follow' : ''}`}
          >
            {text}
          </p>
        ))}
      </div>
    </div>,
    document.body
  );
}

/**
 * Info (i) control that opens the same PnL scaling modal as Vector Results.
 * Pass className to match local button styles (e.g. risk-info-icon-button, info-icon-button).
 */
export function PnlContractsInfoButton({
  className,
  iconSize = 14,
  ariaLabel = 'Open PnL scaling note',
  iconColor,
}) {
  const [open, setOpen] = useState(false);
  const btnClass = className || 'pnl-contracts-info-btn';
  return (
    <>
      <button
        type="button"
        className={btnClass}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={ariaLabel}
        onClick={() => setOpen(true)}
      >
        <IconInfo size={iconSize} color={iconColor || 'currentColor'} />
      </button>
      <PnlScalingInfoModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
